/**
 * Language Switcher Component
 *
 * Provides a UI for switching between supported languages
 */

import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/useLanguage';
import { supportedLanguages } from '@/config/i18n';
import { Languages, Check, Loader2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const languageNames = {
  en: 'English',
  vi: 'Tiếng Việt',
} as const;

export function LanguageSwitcher() {
  const { currentLanguage, changeLanguage, isChanging } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" disabled={isChanging}>
          {isChanging ? (
            <Loader2 className="h-[1.2rem] w-[1.2rem] animate-spin" />
          ) : (
            <Languages className="h-[1.2rem] w-[1.2rem]" />
          )}
          <span className="sr-only">Switch language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {supportedLanguages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => changeLanguage(lang)}
            className={currentLanguage === lang ? 'bg-accent' : ''}
          >
            {languageNames[lang]}
            {currentLanguage === lang && <Check className="h-4 w-4 ml-auto" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
